module.exports = " <div :class=\"[!activity? 'fullBg' : 'relativeBg']\" _v-5edb2982=\"\"> <img :src=bg alt=\"\" _v-5edb2982=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5edb2982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Bg.vue
// module id = 153
// module chunks = 0